module.exports = __webpack_public_path__ + "img/lily white.b6b27ffa.png";